import { render } from "./AboutMeView.vue?vue&type=template&id=c7999ce6&scoped=true"
import script from "./AboutMeView.vue?vue&type=script&lang=js"
export * from "./AboutMeView.vue?vue&type=script&lang=js"

import "./AboutMeView.vue?vue&type=style&index=0&id=c7999ce6&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7999ce6"]])

export default __exports__